export default "__VITE_ASSET__CADQ0sOm__"